
import AlteracaoSenhaUsuarioDialog from "@/components/dialogs/administrativo/usuarios/AlteracaoSenhaUsuarioDialog.vue";
import PhoneInput from "@/components/wmc/PhoneInput.vue";
import UserInterface from "@/interfaces/User";
import UserService from "@/services/UserService";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({
  name: "MinhaContaDialog",
  components: {
    PhoneInput,
    AlteracaoSenhaUsuarioDialog,
  },
})
export default class MinhaContaDialog extends Vue {
  dlgVisible = false;
  dialogExcluirConta = false;
  excluirContaTime = 5;
  userData = {} as UserInterface;

  roleMap = [
    {
      id: "ADMIN",
      label: "Administrador",
    },
    {
      id: "USER",
      label: "Usuário",
    },
    {
      id: "SYNC",
      label: "Sincronização",
    },
  ];

  defaultStyle = {
    "hide-details": true,
    dense: true,
    outlined: true,
    disabled: true,
  };

  @Watch("dialogExcluirConta")
  onDialogExcluirContaChange() {
    if (this.dialogExcluirConta) {
      this.excluirContaTime = 5;
      const interval = setInterval(() => {
        this.excluirContaTime--;
        if (this.excluirContaTime <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  show() {
    UserService.fetchLoggedUserData().then(
      (resp) => {
        this.userData = resp.data;
      },
      (error) => {
        this.$store.dispatch(
          "Notifications/showErrorMessage",
          error?.response?.data || error?.message,
          { root: true }
        );
      }
    );

    this.dlgVisible = true;
  }

  onRedefinirSenhaClick() {
    const dlg = this.$refs.altSenhaDlg as AlteracaoSenhaUsuarioDialog;
    dlg.show();
  }

  get dataCriacao() {
    return new Date(
      this.userData.dataCriacao || new Date()
    ).toLocaleDateString();
  }

  excluirConta() {
    UserService.deleteSelf().then(
      () => {
        this.$store.dispatch(
          "Notifications/showSuccessMessage",
          "Conta excluída com sucesso!",
          {
            root: true,
          }
        );
        this.$store.dispatch("Auth/signOut").then(() => {
          this.$router.push("/home");
        });
      },
      (error) => {
        this.$store.dispatch(
          "Notifications/showErrorMessage",
          error?.response?.data || error?.message,
          { root: true }
        );
      }
    );
  }
}
